"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/** Por ahora te consigue los corporates del usuario, del dependant ahora veremos donde van jeje
 * @param uid del usuario principal
 * @param dependantUid si pasas un uid del dependant, significa que queres que lo busque
 * Todo esto es del nuevo back, nuevo endpoint y nueva forma de guardar los Coverages.
 */
function useCoverages(firestore, uid, dependantUid, queryOptions) {
    const path = dependantUid ? `dependants/${dependantUid}/coverage` : `user/${uid}/coverage`;
    const corporatesRef = (0, firestore_2.collection)(firestore, path);
    const QueryCoveragesRef = (0, firestore_2.query)(corporatesRef, (0, firestore_2.where)("deleted", "==", false));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Corporate({
        name: "patient coverages",
        path: path
    }, [uid, dependantUid]), QueryCoveragesRef, {}, queryOptions);
}
exports.default = useCoverages;
